import { UserAssignCell } from 'app/components/table/UserAssignCell'
import { graphql } from 'app/generated/gql'
import { gqlMutation } from 'app/lib/graphqlClient'
import { notifySuccess } from 'app/services/notify.client'
import { bg } from 'lib/background'
import { OptionType } from 'types/OptionType'

const UPDATE_CONTACT_MUTATION = graphql(`
  mutation UpdateContactTable($id: ID!, $input: UpdateContactInput!) {
    updateContact(id: $id, input: $input) {
      id
    }
  }
`)

/** Row shape the lead-owner cell reads. Kept loose so it fits every contact
 * table row type (attribution, marketing, contacts). */
type LeadOwnerRow = {
  id?: string
  leadOwner?: unknown
  locationId?: string
  workspaceId?: string
}

/** The "Contact Owner" column cell: assign or change a contact's lead owner.
 * Extracted so the three contact tables (attribution-contacts, marketing-details,
 * contacts) share one definition instead of repeating the same block. */
export function LeadOwnerAssignCell({ row }: { row?: LeadOwnerRow }) {
  return (
    <UserAssignCell
      user={row?.leadOwner as any}
      contactId={row?.id}
      locationId={row?.locationId}
      workspaceId={row?.workspaceId}
      firstNameInitial
      onChange={(val?: OptionType) => {
        bg(async () => {
          if (!val?.value) return
          if (!row?.id) return
          await gqlMutation(UPDATE_CONTACT_MUTATION, { id: row.id, input: { leadOwner: val.value } })
          notifySuccess(`Contact Owner updated successfully`)
        })
      }}
    />
  )
}
